// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traduções
import enTranslations from './en.json';
import ptTranslations from './pt.json';

// Inicialização síncrona para garantir disponibilidade imediata
const initI18n = () => {
  const savedLang = localStorage.getItem('i18nextLng');
  
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: enTranslations },
        pt: { translation: ptTranslations }
      },
      fallbackLng: 'en',
      lng: savedLang || 'en',
      debug: process.env.NODE_ENV === 'development',
      interpolation: {
        escapeValue: false
      },
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng'
      },
      react: {
        useSuspense: false // Importante para evitar problemas de renderização
      }
    });
  
  return i18n;
};

// Inicializa imediatamente
initI18n();

// Adiciona ao objeto global para debug
if (process.env.NODE_ENV === 'development') {
  window.i18n = i18n;
  console.log('🌐 i18n inicializado:', {
    language: i18n.language,
    languages: i18n.languages,
    availableLanguages: Object.keys(i18n.options.resources || {})
  });
}

export default i18n;